<div class="sidebar">
  <button class="nav-button" routerLink="/home" routerLinkActive="selected">
    <img src="home/sidebar/home.png" alt="Home">
    <span>{{ 'Home' | translate}}</span>
  </button>
  <button class="nav-button" routerLink="/statistics" routerLinkActive="selected">
    <img src="home/sidebar/statistics.png" alt="Statistics">
    <span>{{ 'Statistics' | translate}}</span>
  </button>
  <button class="nav-button" routerLink="/ride-history" routerLinkActive="selected">
    <img src="home/sidebar/ride-history.png" alt="Ride history">
    <span>{{ 'Ride history' | translate}}</span>
  </button>
  <button class="nav-button" routerLink="/geofence" routerLinkActive="selected">
    <img src="home/sidebar/geofence.png" alt="Geofencing">
    <span>{{ 'Geofencing' | translate}}</span>
  </button>
  <button class="nav-button" routerLink="/settings" routerLinkActive="selected">
    <img src="home/sidebar/settings.png" alt="Settings">
    <span>{{ 'Settings' | translate}}</span>
  </button>
  <button class="nav-button" routerLink="/bike-lock" routerLinkActive="selected">
    <img src="home/sidebar/bike-lock.png" alt="Bike lock">
    <span>{{ 'Bike lock' | translate}}</span>
  </button>
  <!-- Admin-only link -->
  <ng-container *ngIf="user$ | async as currentUser">
    <button *ngIf="(currentUser?.user?.roles || currentUser?.roles || []).includes('ROLE_ADMIN')" class="nav-button" routerLink="/admin" routerLinkActive="selected">
      <img src="home/sidebar/admin.png" alt="Admin">
      <span>Admin</span>
    </button>
  </ng-container>
</div>